import Button, { ButtonTypes } from '@/components/Buttons/Button';
import { Flex, Grid, Text, createStyles } from '@mantine/core';

import { ITechstack } from '@/types/techstack';
import Link from 'next/link';
import TechstackJobCard from './TechstackJobCard';
import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';

export const useTechstackDetailJobpostStyle = createStyles(() => ({
  jobpostCardWrapper: {
    cursor: 'pointer',
    gap: 10,
    overflow: 'hidden',
    borderRadius: 12,
    transition: '300ms all ease',
    ':hover': {
      transform: 'translateY(-3px)',
    },
  },

  headerImage: {
    width: '100%',
    maxHeight: '100%',
    objectFit: 'cover',
    borderRadius: 12,
  },

  imageOverlay: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: 48,
    background: 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)',
    opacity: '0.35',
  },
}));

const TechstackDetailJobpost = ({ data }: { data: ITechstack }) => {
  return data?.job_posts?.length ? (
    <>
      <Flex justify={'space-between'} mt={80}>
        <Text
          size={22}
          weight={600}
          lts={-0.4}
          color={themeVariables.fontColors.extraDark}
        >
          관련 채용 공고
        </Text>
        <Link href={`/jobpost?company_id=${data?.techstack?.id}`}>
          <Button
            type={ButtonTypes.transparentGray}
            style={{ color: themeVariables.label.alternative }}
            onClick={() => {
              mixpanelTrack(
                'TechstackDetailPage_MoreJobpost_Button',
                'Clicked'
              );
            }}
          >
            더 보기
          </Button>
        </Link>
      </Flex>
      <Grid columns={24} gutter={32} mt={16}>
        {data?.job_posts?.slice(0, 12)?.map((item) => (
          <Grid.Col key={item.id} lg={6} md={8} sm={12}>
            <TechstackJobCard jobpost={item} />
          </Grid.Col>
        ))}
      </Grid>
    </>
  ) : null;
};

export default TechstackDetailJobpost;
